import { formatAllDayDates, isAllDay, type AgendaDates } from '@/lib/agendaDates';

export function agendaWhen(event: Partial<AgendaDates>, locale: string): string {
  const value: AgendaDates = { ...event, start_at: event.start_at ?? (event.all_day_start ? event.all_day_start + 'T12:00:00Z' : '') };
  if (isAllDay(value)) return formatAllDayDates(value, locale);
  const start = new Date(value.start_at);
  if (!Number.isFinite(start.getTime())) return '';
  const date = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' });
  const time = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit', hour12: false, timeZoneName: 'short' });
  const end = value.end_at ? new Date(value.end_at) : null;
  return date.format(start) + ' · ' + time.format(start) + (end && Number.isFinite(end.getTime()) ? '–' + time.format(end) + (start.toDateString() !== end.toDateString() ? ' · ' + date.format(end) : '') : '');
}

/** Imported calendar descriptions may be HTML. Render passive text, never source markup. */
export function agendaNoteText(notes: string, source?: string): string {
  if (!['google','google_calendar','outlook','apple','apple_calendar'].includes(source ?? '') || !/<\/?[a-z][^>]*>/iu.test(notes)) return notes;
  // An unattached template keeps imported images/iframes inert as well as scripts.
  const template = document.createElement('template');
  template.innerHTML = notes;
  const doc = template.content;
  doc.querySelectorAll('script,style,noscript,iframe,object,embed,template').forEach(node => node.remove());
  doc.querySelectorAll('a[href]').forEach(node => {
    const href = node.getAttribute('href') ?? '';
    try {
      if (['https:', 'http:'].includes(new URL(href).protocol) && node.textContent?.trim() !== href) node.append(' (' + href + ')');
    } catch { /* The link label remains readable; unsafe targets are never rendered. */ }
  });
  doc.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
  doc.querySelectorAll('p,div,li').forEach(node => node.append('\n'));
  return (doc.textContent ?? '').replace(/\n{3,}/gu, '\n\n').trim();
}
